import { ApiResponse, HTMenu, HTVaiTro, HTTaiKhoan } from '../types/api-response';
import { CaySamUser } from '../types/caysamuser';
import { apiGet, apiPost, apiDelete, buildQueryString } from './api-client';

// ----------------------------------------------------------------------
// SYSTEM API SERVICE
// ----------------------------------------------------------------------

export const systemApiService = {
  // ------------------ VAI TRO (ROLES) ------------------
  
  async listVaiTro(params?: {
    skip?: number;
    take?: number;
    Status?: number;
    rowCount?: number;
    searchBy?: string[];
    orderBy?: string[];
  }): Promise<ApiResponse<HTVaiTro>> {
    const queryString = buildQueryString(params);
    return apiGet<ApiResponse<HTVaiTro>>(
      `/HeThong/ListVaiTro${queryString}`,
      'HeThong',
      'Lấy danh sách vai trò thất bại. Vui lòng thử lại.'
    );
  },

  async getVaiTro(id: string): Promise<ApiResponse<HTVaiTro>> {
    return apiGet<ApiResponse<HTVaiTro>>(
      `/HeThong/VaiTro/${id}`,
      'HeThong',
      'Lấy thông tin vai trò thất bại. Vui lòng thử lại.'
    );
  },

  async createVaiTro(roleData: Partial<HTVaiTro>): Promise<ApiResponse<HTVaiTro>> {
    return apiPost<ApiResponse<HTVaiTro>>(
      '/HeThong/AddVaiTro',
      roleData,
      'HeThong',
      false,
      'Tạo vai trò thất bại. Vui lòng thử lại.'
    );
  },

  async updateVaiTro(id: string, roleData: Partial<HTVaiTro>): Promise<ApiResponse<HTVaiTro>> {
    return apiPost<ApiResponse<HTVaiTro>>(
      `/HeThong/EditVaiTro/${id}`,
      roleData,
      'HeThong',
      false,
      'Cập nhật vai trò thất bại. Vui lòng thử lại.'
    );
  },

  async deleteVaiTro(ids: string[]): Promise<ApiResponse<any>> {
    return apiPost<ApiResponse<any>>(
      '/HeThong/DeleteVaiTro',
      { ids },
      'HeThong',
      false,
      'Xóa vai trò thất bại. Vui lòng thử lại.'
    );
  },


  // ------------------ PHAN QUYEN (PERMISSIONS) ------------------
  
  async listPhanQuyenTaiKhoan(): Promise<ApiResponse<any>> {
    return apiPost<ApiResponse<any>>(
      '/HeThong/ListPhanQuyenTaiKhoan',
      {},
      'HeThong',
      false,
      'Lấy danh sách phân quyền thất bại. Vui lòng thử lại.'
    );
  },

  async getPhanQuyenByTaiKhoan(taiKhoanId: string): Promise<ApiResponse<any>> {
    return apiGet<ApiResponse<any>>(
      `/HeThong/PhanQuyenTaiKhoan/${taiKhoanId}`,
      'HeThong',
      'Lấy phân quyền tài khoản thất bại. Vui lòng thử lại.'
    );
  },

  async updatePhanQuyen(data: {
    taiKhoanId: string;
    permissions: any[];
  }): Promise<ApiResponse<any>> {
    return apiPost<ApiResponse<any>>(
      '/HeThong/UpdatePhanQuyen',
      data,
      'HeThong',
      false,
      'Cập nhật phân quyền thất bại. Vui lòng thử lại.'
    );
  },

  // ------------------ MENU ------------------
  
  async listMenu(params?: {
    skip?: number;
    take?: number;
    Status?: number;
  }): Promise<ApiResponse<HTMenu>> {
    const queryString = buildQueryString(params);
    return apiGet<ApiResponse<HTMenu>>(
      `/HeThong/ListMenu${queryString}`,
      'HeThong',
      'Lấy danh sách menu thất bại. Vui lòng thử lại.'
    );
  },

  async getMenu(id: string): Promise<ApiResponse<HTMenu>> {
    return apiGet<ApiResponse<HTMenu>>(
      `/HeThong/Menu/${id}`,
      'HeThong',
      'Lấy thông tin menu thất bại. Vui lòng thử lại.'
    );
  },

  async createMenu(menuData: Partial<HTMenu>): Promise<ApiResponse<HTMenu>> {
    return apiPost<ApiResponse<HTMenu>>(
      '/HeThong/AddMenu',
      menuData,
      'HeThong',
      false,
      'Tạo menu thất bại. Vui lòng thử lại.'
    );
  },

  async updateMenu(id: string, menuData: Partial<HTMenu>): Promise<ApiResponse<HTMenu>> {
    return apiPost<ApiResponse<HTMenu>>(
      `/HeThong/EditMenu/${id}`,
      menuData,
      'HeThong',
      false,
      'Cập nhật menu thất bại. Vui lòng thử lại.'
    );
  },

  async deleteMenu(ids: string[]): Promise<ApiResponse<any>> {
    return apiPost<ApiResponse<any>>(
      '/HeThong/DeleteMenu',
      { ids },
      'HeThong',
      false,
      'Xóa menu thất bại. Vui lòng thử lại.'
    );
  },

  // ------------------ CAY SAM USER ------------------
  
  async GetCaySamByUser(): Promise<ApiResponse<CaySamUser>> {
    return apiGet<ApiResponse<CaySamUser>>(
      '/HeThong/GetCaySamsByUser',
      'HeThong',
      'Lấy dữ liệu cây sâm thất bại. Vui lòng thử lại.'
    );
  },

  // ------------------ SYSTEM SETTINGS ------------------
  
  async getSystemSettings(): Promise<ApiResponse<any>> {
    return apiGet<ApiResponse<any>>(
      '/HeThong/GetSettings',
      'HeThong',
      'Lấy cài đặt hệ thống thất bại. Vui lòng thử lại.'
    );
  },
  async linkGoogle(data: { idToken: string; deviceToken: string}): Promise<ApiResponse<any>> {
      return apiPost<ApiResponse<any>>(
        '/HeThong/LinkGoogle',
        data,
        'HeThong',
        false,
        'Lấy link google thất bại. Vui lòng thử lại.'
      ); 
    },
  async updateSystemSettings(settings: any): Promise<ApiResponse<any>> {
    return apiPost<ApiResponse<any>>(
      '/HeThong/UpdateSettings',
      settings,
      'HeThong',
      false,
      'Cập nhật cài đặt hệ thống thất bại. Vui lòng thử lại.'
    );
  },
};

export default systemApiService;